import React, { useEffect, useState } from 'react';
import { AppIcon } from '../../../components/icons/AppIcon';

interface SidebarModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
}

export const SidebarModal: React.FC<SidebarModalProps> = ({
    isOpen,
    onClose,
    title,
    children
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
        } else {
            const timer = setTimeout(() => setIsVisible(false), 300); // Matches transition duration
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    if (!isVisible && !isOpen) return null;

    return (
        <div
            className={`absolute inset-0 z-50 bg-card flex flex-col transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
                }`}
        >
            <div className="flex items-center gap-3 p-4 bg-card flex-shrink-0 border-b border-border">
                <button
                    onClick={onClose}
                    className="p-1 rounded-full hover:bg-muted/10 text-muted transition-colors"
                >
                    <AppIcon name="arrow-left" className="w-5 h-5" strokeWidth={1.75} />
                </button>
                <h2 className="chat-section-heading uppercase tracking-tight">{title}</h2>
            </div>
            <div className="flex-1 overflow-y-auto p-4 custom-scrollbar">
                {children}
            </div>
        </div>
    );
};
